import { IAppState } from '../../common/state';
import { getGenplan } from './getGenplan';

export function getIsGenplanAvailable(state: IAppState): boolean {
  return Boolean(getGenplan(state));
}
